import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MetaTags from 'components/common/MetaTags';
import DashboardLayout from 'components/dashboard/DashboardLayout';
import DashboardVolunteer from 'components/dashboard/DashboardVolunteer';
import { getActiveSeason } from 'api/season';
import { getUserInfo } from 'services/auth/tokenService';

const VolunteerStatus = () => {
  const userInfo = JSON.parse(getUserInfo());
  const { selectedClub } = useSelector((state) => state.user || {});

  const [seasonName, setSeasonName] = useState('');

  useEffect(() => {
    if (!selectedClub?.clubID) return;
    getActiveSeason(selectedClub.clubID)
      .then((res) => setSeasonName(res.data?.name || ''))
      .catch((err) => {
        console.log('[VolunteerStatus] Fetch active season error: ', err);
        setSeasonName('');
      });
  }, [selectedClub?.clubID]);

  return (
    <>
      <MetaTags title="SplitFast | My Volunteer Status" />
      <DashboardLayout
        title="My Volunteer Status"
        seasonName={seasonName}
        clubName={selectedClub?.clubName}
        userName={`${userInfo?.firstName} ${userInfo?.lastName}`}
      >
        <DashboardVolunteer clubId={selectedClub?.clubID} />
      </DashboardLayout>
    </>
  );
};

export default VolunteerStatus;
